import LookupLocationsRequestModelBase from '../_generated/modelBases/lookup-locations-request-model-base';

export default class LookupLocationsRequestModel extends LookupLocationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
